// Utils
import cntl from "cntl";
import PropTypes from "prop-types";

// HOCs
import withContainer from "@dbox/components/atoms/HOCs/transfer/withContainer";

const propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

const Container = ({ title, className, children }) => {
  const boxCn = () => cntl`
    ${className ? className : undefined}
  `;

  return <div className={boxCn()}>{children}</div>;
};

Container.propTypes = propTypes;
export default withContainer(Container);
